import "./job-card.css";

import CircleIcon from "@mui/icons-material/Circle";

const JobCard = (props) => {
	return (
		<article>
			<h3>{props.data.title}</h3>
			<p className="hint">{props.data.companyName}</p>
			<p className="hint">
				{props.data.start}-{props.data.end ?? "Present"}
			</p>

			{props.data.timeline.length > 0 && (
				<section className="timeline">
					{props.data.timeline.map((x, i) => (
						<section className="timelineNode" key={i}>
							<CircleIcon
								style={{
									fill: "white",
									fontSize: "40px",
								}}
							/>
							<p className="timelineNode-date">{x.date}</p>
							<p className="timelineNode-date hint">{x.tag}</p>
						</section>
					))}
				</section>
			)}

			<h3>Key Responsibilities</h3>
			<ul className="keyResponsibilities">
				{props.data.responsibilities.map((x, i) => (
					<li key={i}>
						<p>{x}</p>
					</li>
				))}
			</ul>
		</article>
	);
};

export default JobCard;
